<button (click)="valueChange(!value)" [disabled]="isDisabled" [class.disabled]="isDisabled">
  <i *ngIf="value" class="icon-accept"></i>
  <i *ngIf="!value" class="icon-none"></i>
</button>
